var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrochure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.748,
    height: 60.078,
    viewBox: "0 0 77.748 60.078",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_import_contacts_24px",
    d: "M71.68,6.267A41.717,41.717,0,0,0,59.311,4.5C52.419,4.5,45,5.914,39.874,9.8,34.75,5.914,27.328,4.5,20.437,4.5S6.124,5.914,1,9.8V61.574a1.9,1.9,0,0,0,1.767,1.767c.353,0,.53-.177.883-.177a43.134,43.134,0,0,1,16.786-3.887c6.891,0,14.313,1.414,19.437,5.3,4.771-3,13.429-5.3,19.437-5.3,5.831,0,11.839,1.06,16.786,3.711a1.593,1.593,0,0,0,.883.177A1.9,1.9,0,0,0,78.748,61.4V9.8A24.1,24.1,0,0,0,71.68,6.267Zm0,47.709a41.067,41.067,0,0,0-12.369-1.767c-6.008,0-14.666,2.3-19.437,5.3V16.869c4.771-3,13.429-5.3,19.437-5.3A41.066,41.066,0,0,1,71.68,13.335Z",
    transform: "translate(-1 -4.5)",
    fill: "#e3e3e3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrochure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Brochure.14d277013f69806fbc21a8f008d00e1c.svg";